import createVueComponent from '../createVueComponent';

const MousePointer = createVueComponent('MousePointerIcon', [
  ['path', { d: 'm3 3 7.07 16.97 2.51-7.39 7.39-2.51L3 3z', key: 'y2ucgo' }],
  ['path', { d: 'm13 13 6 6', key: '1nhxnf' }],
]);

export default MousePointer;
